import {FormControl, FormHelperText, Input, InputLabel} from "@material-ui/core"
import React from "react"

/**
 * An input control to handle the specification of a person's full name.
 *
 * @param fullName: {String} The current full name value.
 * @param fullNameError: {String} The validation error currently associated to the full name value.
 * @param classes: {Object} representing the JSS classes for the input.
 * @param label: {String} The label (or title) to display in the input.
 * @param changeFullName: A handler that should be invoked passing the event that raised it, along with a boolean
 * specifying when it's desired that such event triggered validation.
 * @param preventWrongKeysForFullName: {Function} A handler to be invoked and determines whether the pressed key can be
 * accepted or not.
 * @param restOfProps: {Object} With the remaining properties to be applied to the input itself.
 */
const FullNameInput = ({
                           fullName,
                           fullNameError,
                           classes = {},
                           label = "Nombre y Apellido",
                           changeFullName = (event, shouldValidate = false) => null,
                           preventWrongKeysForFullName = event => null,
                           tabIndex = 1,
                           ...restOfProps
                       }) => (
    <FormControl className={classes.formControl}
                 fullWidth={true} error={fullName !== null && fullNameError !== ""}
                 aria-describedby="nameError">

        <InputLabel htmlFor="name">{label}</InputLabel>

        <Input id="name"
               onChange={event => changeFullName(event)}
               onKeyDown={preventWrongKeysForFullName}
               onBlur={event => changeFullName(event, true)}
               inputProps={{maxLength: 60, autoComplete: 'off', spellCheck: "false", tabIndex}}
               onPaste={event => event.preventDefault()}
               onDrop={event => event.preventDefault()}
               value={fullName}
               {...restOfProps}/>

        <FormHelperText id="nameError">{fullNameError}</FormHelperText>
    </FormControl>
)

export default FullNameInput